var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import Characteristic from "./Characteristic";
import Credential from "./Credential";
import moment from "moment";
export var CharacteristicType;
(function (CharacteristicType) {
    CharacteristicType["NAME"] = "NAME";
    CharacteristicType["FIRST_NAME"] = "FIRST_NAME";
    CharacteristicType["LAST_NAME"] = "LAST_NAME";
    CharacteristicType["BIRTH_DATE"] = "BIRTH_DATE";
    CharacteristicType["EMAIL"] = "EMAIL";
    CharacteristicType["NATIONALITY"] = "NATIONALITY";
    CharacteristicType["COUNTRY_OF_RESIDENCE"] = "COUNTRY_OF_RESIDENCE";
    CharacteristicType["BUSINESS_NAME"] = "BUSINESS_NAME";
    CharacteristicType["LEGAL_IDENTIFIER"] = "LEGAL_IDENTIFIER";
    CharacteristicType["ADDRESS"] = "ADDRESS";
    CharacteristicType["DELIVERY_ADDRESS"] = "DELIVERY_ADDRESS";
    CharacteristicType["BILLING_ADDRESS"] = "BILLING_ADDRESS";
    CharacteristicType["FACEBOOK_ID"] = "FACEBOOK_ID";
    CharacteristicType["GOOGLE_ID"] = "GOOGLE_ID";
    CharacteristicType["LINKEDIN_ID"] = "LINKEDIN_ID";
    CharacteristicType["APPLE_ID"] = "APPLE_ID";
    CharacteristicType["LEGAL_FORM"] = "LEGAL_FORM";
    CharacteristicType["LEGAL_REPRESENTATIVE"] = "LEGAL_REPRESENTATIVE";
    CharacteristicType["GENDER"] = "GENDER";
    CharacteristicType["PROFILE_PICTURE"] = "PROFILE_PICTURE";
    CharacteristicType["PHONE_NUMBER"] = "PHONE_NUMBER";
    CharacteristicType["UNDEFINED"] = "UNDEFINED";
})(CharacteristicType || (CharacteristicType = {}));
export var EditableCharacteristicType;
(function (EditableCharacteristicType) {
    EditableCharacteristicType["EMAIL"] = "EMAIL";
    EditableCharacteristicType["NAME"] = "NAME";
    EditableCharacteristicType["FIRST_NAME"] = "FIRST_NAME";
    EditableCharacteristicType["LAST_NAME"] = "LAST_NAME";
    EditableCharacteristicType["BIRTH_DATE"] = "BIRTH_DATE";
    EditableCharacteristicType["NATIONALITY"] = "NATIONALITY";
    EditableCharacteristicType["COUNTRY_OF_RESIDENCE"] = "COUNTRY_OF_RESIDENCE";
    EditableCharacteristicType["BUSINESS_NAME"] = "BUSINESS_NAME";
    EditableCharacteristicType["LEGAL_IDENTIFIER"] = "LEGAL_IDENTIFIER";
    EditableCharacteristicType["ADDRESS"] = "ADDRESS";
    EditableCharacteristicType["GENDER"] = "GENDER";
    EditableCharacteristicType["LEGAL_REPRESENTATIVE"] = "LEGAL_REPRESENTATIVE";
    EditableCharacteristicType["PROFILE_PICTURE"] = "PROFILE_PICTURE";
    EditableCharacteristicType["UNDEFINED"] = "UNDEFINED";
    EditableCharacteristicType["LEGAL_FORM"] = "LEGAL_FORM";
    EditableCharacteristicType["PHONE_NUMBER"] = "PHONE_NUMBER";
})(EditableCharacteristicType || (EditableCharacteristicType = {}));
export var ResourceType;
(function (ResourceType) {
    ResourceType["USER"] = "USER";
    ResourceType["COMPANY"] = "COMPANY";
    ResourceType["BOT"] = "BOT";
    ResourceType["PROFILE"] = "PROFILE";
})(ResourceType || (ResourceType = {}));
var Resource = /** @class */ (function (_super) {
    __extends(Resource, _super);
    function Resource(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.characteristics = [];
        _this.sendRegistrationEmailIfApplicable = true;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        buildFromJson(_this, obj);
        function buildFromJson(instance, json) {
            if (json) {
                for (var prop in json) {
                    if (json.hasOwnProperty(prop)) {
                        if (prop === 'characteristics') {
                            instance[prop] = [];
                            for (var subProp in json[prop]) {
                                if (json[prop].hasOwnProperty(subProp)) {
                                    instance[prop].push(new Characteristic(json[prop][subProp]));
                                }
                            }
                        }
                        else if (prop === 'credentials') {
                            instance[prop] = new Credential(json[prop]);
                        }
                        else if (prop === 'type') {
                            instance['resourceType'] = json[prop];
                        }
                        else {
                            instance[prop] = json[prop];
                        }
                    }
                }
            }
        }
        return _this;
    }
    Resource.prototype.exportToJson = function () {
        var JSONCharacteristic = {};
        JSONCharacteristic["uid"] = this.uid;
        JSONCharacteristic["characteristics"] = [];
        for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
            var characteristic = _a[_i];
            JSONCharacteristic["characteristics"].push(characteristic.exportToJson());
        }
        JSONCharacteristic.resourceType = this.resourceType;
        JSONCharacteristic.sendRegistrationEmailIfApplicable = this.sendRegistrationEmailIfApplicable;
        return JSONCharacteristic;
    };
    /**
     * Export only editable characteristics
     */
    Resource.prototype.exportToJsonEditable = function () {
        var JSONCharacteristic = {};
        JSONCharacteristic["uid"] = this.uid;
        JSONCharacteristic["characteristics"] = [];
        for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
            var characteristic = _a[_i];
            var editable = false;
            for (var type in EditableCharacteristicType) {
                if (characteristic.type === type) {
                    editable = true;
                    break;
                }
            }
            if (editable) {
                JSONCharacteristic["characteristics"].push(characteristic.exportToJson());
            }
        }
        JSONCharacteristic.resourceType = this.resourceType;
        JSONCharacteristic.sendRegistrationEmailIfApplicable = this.sendRegistrationEmailIfApplicable;
        return JSONCharacteristic;
    };
    Resource.prototype.getAllEmailCharacteristics = function () {
        var emails = [];
        for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
            var characteristic = _a[_i];
            if (characteristic.type === CharacteristicType.EMAIL && !characteristic.endDate) {
                emails.push(characteristic);
            }
        }
        return emails;
    };
    Resource.prototype.getAllAddressCharacteristics = function () {
        var addresses = [];
        for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
            var characteristic = _a[_i];
            if (characteristic.type === CharacteristicType.ADDRESS && !characteristic.endDate) {
                addresses.push(characteristic);
            }
        }
        return addresses;
    };
    Resource.prototype.setEmails = function (emails) {
        // First remove all emails characteristics
        for (var i = this.characteristics.length - 1; i >= 0; i--) {
            if (this.characteristics[i].type === CharacteristicType.EMAIL) {
                if (this.characteristics[i].uid && !this.characteristics[i].endDate) {
                    var isIn = false;
                    for (var _i = 0, emails_1 = emails; _i < emails_1.length; _i++) {
                        var email = emails_1[_i];
                        if (this.characteristics[i].uid === email.uid) {
                            isIn = true;
                            break;
                        }
                    }
                    if (!isIn) {
                        this.characteristics[i].endDate = moment().format('YYYY-MM-DDTHH:mm:ss');
                    }
                    else {
                        this.characteristics.splice(i, 1);
                    }
                }
                else {
                    this.characteristics.splice(i, 1);
                }
            }
        }
        // Set new emails
        this.characteristics = this.characteristics.concat(emails);
    };
    Object.defineProperty(Resource.prototype, "haveAppleId", {
        get: function () {
            return this.get(CharacteristicType.APPLE_ID) !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "haveFacebookId", {
        get: function () {
            return this.get(CharacteristicType.FACEBOOK_ID) !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "haveLinkedinId", {
        get: function () {
            return this.get(CharacteristicType.LINKEDIN_ID) !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "haveGoogleId", {
        get: function () {
            return this.get(CharacteristicType.GOOGLE_ID) !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "email", {
        /** Setter & Getter of Characteristics**/
        get: function () {
            return this.get(CharacteristicType.EMAIL);
        },
        set: function (value) {
            this.set(CharacteristicType.EMAIL, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "billing_addresses", {
        get: function () {
            return this.getAll(CharacteristicType.BILLING_ADDRESS);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "phone_number", {
        get: function () {
            return this.get('PHONE_NUMBER');
        },
        set: function (value) {
            this.set(CharacteristicType.UNDEFINED, {
                key: 'PHONE_NUMBER',
                value: value
            });
        },
        enumerable: false,
        configurable: true
    });
    Resource.prototype.setSpecificNumber = function (type, value) {
        var phoneCharacteristics = this.getAll(CharacteristicType.PHONE_NUMBER);
        for (var _i = 0, phoneCharacteristics_1 = phoneCharacteristics; _i < phoneCharacteristics_1.length; _i++) {
            var characteristic = phoneCharacteristics_1[_i];
            if (characteristic.value && characteristic.value.type === type) {
                characteristic.value.number = value;
                return;
            }
        }
        // If not already existing
        this.addCharacteristic(CharacteristicType.PHONE_NUMBER, {
            indicator: '',
            number: value,
            type: type
        });
    };
    Resource.prototype.getSpecificNumber = function (type) {
        var phoneCharacteristics = this.getAll(CharacteristicType.PHONE_NUMBER);
        for (var _i = 0, phoneCharacteristics_2 = phoneCharacteristics; _i < phoneCharacteristics_2.length; _i++) {
            var characteristic = phoneCharacteristics_2[_i];
            if (characteristic.value && characteristic.value.type === type) {
                return characteristic.value.number;
            }
        }
        return null;
    };
    Object.defineProperty(Resource.prototype, "personal_landline", {
        get: function () {
            return this.getSpecificNumber('PERSONAL_LANDLINE');
        },
        set: function (value) {
            this.setSpecificNumber('PERSONAL_LANDLINE', value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "personal_cellphone", {
        get: function () {
            return this.getSpecificNumber('PERSONAL_CELLPHONE');
        },
        set: function (value) {
            this.setSpecificNumber('PERSONAL_CELLPHONE', value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "professional_landline", {
        get: function () {
            return this.getSpecificNumber('PROFESSIONAL_LANDLINE');
        },
        set: function (value) {
            this.setSpecificNumber('PROFESSIONAL_LANDLINE', value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "professional_cellphone", {
        get: function () {
            return this.getSpecificNumber('PROFESSIONAL_CELLPHONE');
        },
        set: function (value) {
            this.setSpecificNumber('PROFESSIONAL_CELLPHONE', value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "profile_picture", {
        get: function () {
            return this.get(CharacteristicType.PROFILE_PICTURE);
        },
        set: function (value) {
            this.set(CharacteristicType.PROFILE_PICTURE, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "comment", {
        get: function () {
            return this.get('COMMENT');
        },
        set: function (value) {
            this.set(CharacteristicType.UNDEFINED, {
                key: 'COMMENT',
                value: value
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "office", {
        get: function () {
            return this.get('OFFICE');
        },
        set: function (value) {
            this.set(CharacteristicType.UNDEFINED, {
                key: 'OFFICE',
                value: value
            });
        },
        enumerable: false,
        configurable: true
    });
    Resource.prototype.set = function (attribute, value) {
        if (value !== null) {
            var isAlreadyExist = false;
            // It may have many UNDEFINED attributes, find the good one
            if (attribute === 'UNDEFINED') {
                if (value.key !== null && value.key !== undefined && value.key !== '') {
                    for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
                        var characteristic = _a[_i];
                        if (characteristic.type === 'UNDEFINED' && !characteristic.endDate) {
                            try {
                                if (characteristic.value.key === value.key) {
                                    isAlreadyExist = true;
                                    characteristic.value = value;
                                }
                            }
                            catch (err) {
                                console.error(err);
                                return;
                            }
                        }
                    }
                }
            }
            else {
                for (var _b = 0, _c = this.characteristics; _b < _c.length; _b++) {
                    var characteristic = _c[_b];
                    if (characteristic.type === attribute && !characteristic.endDate) {
                        isAlreadyExist = true;
                        characteristic.value = value;
                    }
                }
            }
            if (!isAlreadyExist) {
                this.characteristics.push(new Characteristic({ type: attribute, value: JSON.stringify(value) }));
            }
        }
    };
    Resource.prototype.get = function (attribute) {
        var matchingUndefined = null;
        for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
            var characteristic = _a[_i];
            if (characteristic.type === attribute && !characteristic.endDate) {
                try {
                    return JSON.parse(characteristic.value);
                }
                catch (error) {
                    return characteristic.value;
                }
            }
            else {
                if (characteristic.type === 'UNDEFINED' && !characteristic.endDate) {
                    try {
                        if (characteristic.value.key === attribute) {
                            matchingUndefined = characteristic.value.value;
                        }
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
            }
        }
        if (matchingUndefined) {
            return matchingUndefined;
        }
        return null;
    };
    Resource.prototype.getCharacteristic = function (attribute) {
        var matchingUndefined = null;
        for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
            var characteristic = _a[_i];
            if (characteristic.type === attribute) {
                return characteristic;
            }
            else {
                if (characteristic.type === 'UNDEFINED') {
                    try {
                        if (characteristic.value.key === attribute) {
                            matchingUndefined = characteristic;
                        }
                    }
                    catch (error) {
                        console.error(error);
                        return null;
                    }
                }
            }
        }
        if (matchingUndefined) {
            return matchingUndefined;
        }
        return null;
    };
    Resource.prototype.addCharacteristic = function (attribute, value) {
        this.characteristics.unshift(new Characteristic({ type: attribute, value: JSON.stringify(value) }));
    };
    Resource.prototype.getAll = function (attribute) {
        var characteristics = [];
        for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
            var characteristic = _a[_i];
            if (characteristic.type === attribute) {
                characteristics.push(characteristic);
            }
        }
        return characteristics;
    };
    Object.defineProperty(Resource.prototype, "fullname", {
        get: function () {
            var _a, _b, _c;
            if (this.get(CharacteristicType.BUSINESS_NAME) !== null) {
                return (_a = this.get(CharacteristicType.BUSINESS_NAME)) !== null && _a !== void 0 ? _a : "";
            }
            else if (this.get(CharacteristicType.FIRST_NAME) !== null) {
                return (_c = (_b = this.get(CharacteristicType.FIRST_NAME)) !== null && _b !== void 0 ? _b : "" + ' ' + this.get(CharacteristicType.LAST_NAME)) !== null && _c !== void 0 ? _c : "";
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    return Resource;
}(Model));
export default Resource;
//# sourceMappingURL=Resource.js.map